export enum SvgTypeEnum {
	ACCOUNTS = 'accounts',
	ACKNOWLEDGE = 'acknowledge',
	ACTIVATIONS = 'activations',
	ARCHIVING = 'archiving',
	ARROW_DOWN = 'arrowDown',
	ARROW_LEFT = 'arrowLeft',
	ARROW_RIGHT = 'arrowRight',
	ARROW_UP = 'arrowUp',
	ASSIGN = 'assign',
	AUTHORITIES_BADGE = 'authoritiesBadge',
	BUSINESS_PREMISES = 'businessPremises',
	CHECK = 'check',
	CHECKERED_FLAG = 'checkeredFlag',
	CHEVRON_LEFT = 'chevronLeft',
	CHEVRON_RIGHT = 'chevronRight',
	CLEAR = 'clear',
	COMPLAIN = 'complain',
	CONTACT = 'contact',
	CONTRACT = 'contract',
	DASHBOARD = 'dashboard',
	DATACENTER = 'datacenter',
	DECOMMISSION = 'decommission',
	DEFAULT = 'default',
	DETAILS = 'details',
	DOCUMENTATION = 'documentation',
	DOWNLOAD = 'download',
	ELSTER_SUBMIT = 'elsterSubmit',
	ERROR = 'error',
	ERS = 'ers',
	FILTER = 'filter',
	IMPORT = 'import',
	KEYWORD = 'keyword',
	LICENCES = 'licences',
	LOCKED = 'locked',
	MAGNIFIER = 'magnifier',
	MANAGE_TENANT = 'manageTenant',
	MANIFEST = 'manifest',
	MANIFEST_ASSIGN = 'manifestAssign',
	MANUAL_EXPORT = 'manualExport',
	MESSAGE = 'message',
	MY_ACCOUNT = 'myAccount',
	NO_ASSIGNMENT = 'noAssignment',
	NO_ICON = 'noIcon',
	NOTIFICATION_BELL = 'notificationBell', // "tasks"
	ORGANIZATION = 'organizations',
	PATCH = 'patch',
	REACTIVATE = 'reactivate',
	RELOAD = 'reload',
	RESET = 'reset',
	RETURN = 'return',
	REVERT = 'revert',
	SIGNATURES = 'signatures',
	SIGNATURE_PACKAGES = 'signaturePackages',
	STAR = 'star',
	STATUS = 'status',
	STRUCTURE = 'structure',
	SUSPENDED = 'suspended',
	TENANTS = 'tenants',
	TRANSACTIONS = 'transactions',	// unused and not in config
	TSS = 'tss',
	TSS_MODE_CLOUD = 'tssModeCloud',
	TSS_MODE_OFFLINE = 'tssModeOffline',
	TSS_MODE_TOKEN = 'tssModeToken',
	UNLOCKED = 'unlocked',
	UPLOAD = 'upload',
	USAGE = 'usage',
	USERS = 'users',
}

export enum SvgStateEnum {
	ACTIVE = 'active',
	DISABLED = 'disabled',
	ERROR = 'error',
	HOVER = 'hover',
	NORMAL = 'normal',
}

export enum SvgSizeEnum {
	MEDIUM = 'svg-size--medium',
	LARGE = 'svg-size--large',
	SMALL = 'svg-size--small'
}

export interface ISvgConfig {
	dimensions: {
		viewBoxX?: number;
		viewBoxY?: number;
		viewBoxWidth: number;
		viewBoxHeight: number;
		width?: number;
		height?: number;
	};
}
